import { User } from "@common/utils/graphql";
import { atom, selector } from "recoil";

type ImpersonatableUser = {
  impersonatableUsers: User[];
  impersonatingUser: User | null;
};

export const impersonatableUserState = atom<ImpersonatableUser>({
  key: "impersonatableUserState",
  default: {
    impersonatableUsers: [],
    impersonatingUser: null,
  },
});

export const isImpersonatingState = selector({
  key: "isImpersonatingState",
  get: ({ get }) => {
    const impersonatableUser = get(impersonatableUserState);
    return !!impersonatableUser.impersonatingUser;
  },
});

export const isImpersonatableState = selector({
  key: "isImpersonatableState",
  get: ({ get }) => {
    const impersonatableUser = get(impersonatableUserState);
    return impersonatableUser.impersonatableUsers.length > 0;
  },
});
